import type { UniversalOnboardingCardBinding } from '../services/funnels';

/**
 * Onboarding needs only release/style identity, preview metadata and the
 * exact ordered default composition. Canonical blueprint HTML stays server-side.
 */
export const toUniversalOnboardingCardSummary = (
  card: Record<string, unknown>,
): UniversalOnboardingCardBinding => {
  const { default_blueprints: _discardedBlueprintPayload, ...summary } = card;
  return {
    ...summary,
    source: 'universal',
  } as UniversalOnboardingCardBinding;
};
